/**
 * Do not change order of `en,de,fr,nl,cs,da,it,no,pl,pt,ru,ro,es,sv,tr`
 *
 * Source: https://www.localeplanet.com/icu/
 */
export const DefaultDataLanguages: Array<string> = [
    'de',
    'en',
    'fr',
    'nl',
    'cs',
    'da',
    'it',
    'nb',
    'pl',
    'pt',
    'ru',
    'ro',
    'es',
    'sv',
    'tr', // 'no' removed with spring 2024 release
    // new in fall 2023
    'bg',
    'fi',
    'ga',
    'hu',
    'lv',
    'sk',
    // new in spring 2024
    'af',
    'ca',
    'el',
    'et',
    'hr',
    'id',
    'ja',
    'ko',
    'lt',
    'mk',
    'sl',
    'sq',
    'sr',
    'uk',
    'vi',
    'zh',
];

export function validDataLanguage(value: string): boolean {
    return DefaultDataLanguages.includes(value);
}

const LocaleAliasMap: Map<string, string> = new Map<string, string>([
    ['en', 'en_US'],
    ['de', 'de_DE'],
    ['fr', 'fr_FR'],
    ['nl', 'nl_NL'],
    ['cs', 'cs_CZ'],
    ['da', 'da_DK'],
    ['it', 'it_IT'],
    ['no', 'nn_NO'],
    ['pl', 'pl_PL'],
    ['pt', 'pt_PT'],
    ['ru', 'ru_RU'],
    ['ro', 'ro_RO'],
    ['es', 'es_ES'],
    ['sv', 'sv_SE'],
    ['tr', 'tr_TR'],
    // fall 2023
    ['bg', 'bg_BG'],
    ['fi', 'fi_FI'],
    ['ga', 'ga_IE'],
    ['hu', 'hu_HU'],
    ['lv', 'lv_LV'],
    ['sk', 'sk_SK'],
    // spring 2024
    ['af', 'af_ZA'],
    ['ca', 'ca_ES'],
    ['el', 'el_GR'],
    ['et', 'et_EE'],
    ['hr', 'hr_HR'],
    ['id', 'id_ID'],
    ['ja', 'ja_JP'],
    ['ko', 'ko_KR'],
    ['lt', 'lt_LT'],
    ['mk', 'mk_MK'],
    ['nb', 'nb_NO'],
    ['sl', 'sl_SL'],
    ['sq', 'sq_AL'],
    ['sr', 'sr_RS'],
    ['uk', 'uk_UA'],
    ['vi', 'vi_VN'],
    ['zh', 'zh_CN'],
]);

export const LanguageMap: Map<string, string> = new Map<string, string>([
    ['en', 'English'],
    ['de', 'Deutsch'],
    ['fr', 'Français'],
    ['nl', 'Nederlands'],
    ['cs', 'Český'],
    ['da', 'Dansk'],
    ['it', 'Italiano'],
    ['pl', 'Polski'],
    ['pt', 'Português'],
    ['nb', 'Norsk'],
    ['ru', 'Русский'],
    ['ro', 'Română'],
    ['es', 'Español'],
    ['sv', 'Svenska'],
    ['tr', 'Türkçe'],
    // fall 2023
    ['bg', 'български'],
    ['fi', 'Suomi'],
    ['ga', 'Gaeilge'],
    ['hu', 'Magyar'],
    ['lv', 'Latviešu'],
    ['sk', 'Slovenčina'],
    // spring 2024
    ['af', 'Afrikaans'],
    ['ca', 'Català'],
    ['el', 'Ελληνικά'],
    ['et', 'Eesti keel'],
    ['hr', 'Hrvatski'],
    ['id', 'Bahasa Indonesia'],
    ['ja', '日本語'],
    ['ko', '한국인'],
    ['lt', 'Lietuvių'],
    ['mk', 'македонски'],
    ['sl', 'Slovenščina'],
    ['sq', 'Shqiptare'],
    ['sr', 'Српски'],
    ['uk', 'українська'],
    ['vi', 'Tiếng Việt'],
    ['zh', '中國人'],
]);

export function getLocale(language: string | undefined): string {
    return LocaleAliasMap.get(language ?? 'en') ?? 'en_US';
}
